import React, { useEffect, useState } from 'react';
import './styles/terminalDetailsIndex.css';
import {
	colorToRgba,
	formatDateTime,
	formatNumWithCommaNairaSymbolTwo,
	getActionNamesByPolicyName,
	trimLongString,
} from '../../../../../../../utils/helper/Helper';
import { icons } from '../../../../../../../assets/icons';
import { bankboxAPI } from '../../../../../../../redux/bankbox';
import RootState, { BankBoxData } from '../../../../../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	RavenActionBar,
	RavenBadge,
	RavenCopyText,
	RavenModal,
	toast,
} from '@ravenpay/raven-bank-ui';
import EmptyScreen from '../../../../../../../components/common/emptyScreen';
import { useDarkMode } from '../../../../../../../hooks/useDarkMode';
import DeleteModal from '../../../../../../../components/common/deleteModal/DeleteModal';
import FlierTwoIndex from '../../../../terminals/component/FlierTwoBox/FlierTwoIndex';
import { ALL_ROUTES } from '../../../../../../../routes/dashboard/overview/AllPathNames';
import Pagination from '../../../../../../../components/common/pagination';
import SmartFilter from '../../../../../../../components/common/smartFilter';
import { debounce } from 'lodash';
import TerminalTable from './components/TerminalTable';
import ViewToggle from './components/ViewToggle';

export interface UserTerminalDetail {
	name?: string;
	serialNo?: number;
	assignee?: string;
	volume?: number;
}
type showModalProp = {
	create: boolean;
	export: boolean;
	Set_to_In_Approved: boolean;
	Set_to_Dispatched: boolean;
	View_Details: boolean;
};

const UserVirtualTerminalDetails = () => {
	const usersSvg = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="22"
			fill="none"
			viewBox="0 0 22 22"
			className="img"
		>
			<circle cx="11" cy="11" r="11" fill="#F7F7F7"></circle>
			<path
				stroke="#8B8B8B"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.097"
				d="M12.939 6.438a2.41 2.41 0 0 1 1.305 2.156c0 .945-.531 1.762-1.305 2.156m1.044 2.799c.79.365 1.5.961 2.089 1.729m-10.443 0c1.016-1.325 2.396-2.14 3.916-2.14s2.9.815 3.916 2.14m-1.566-6.684c0 1.329-1.052 2.406-2.35 2.406s-2.35-1.077-2.35-2.406 1.052-2.406 2.35-2.406 2.35 1.077 2.35 2.406"
			></path>
		</svg>
	);

	// State to manage dropdown visibility for each card
	const [theme] = useDarkMode(localStorage.getItem('theme'));
	// Function to check if the dropdown for a given serialNo is open

	const dispatch = useDispatch();
	const {
		single_bankbox,
		user_merchant,
		all_bankbox__merchant,
		virtual_bankbox__merchant,
	} = useSelector((state: RootState) => state.bankbox);
	console.log(virtual_bankbox__merchant);

	const {
		loading,
	}: { all_bankbox: any; loading: boolean; all_bankbox_data: any } =
		useSelector((state: RootState) => state.bankbox);
	const [showAction, setShowAction] = useState(false);
	const [showFlier, setShowFlier] = useState(false);
	const [captureImg, setCaptureImg] = useState(false);

	const [refreshTable, setRefreshTable] = useState(false);
	const { profile } = useSelector((state: RootState) => state.settings);

	const getFlierFunc = async (param: any) => {
		const resp = await dispatch(bankboxAPI.getSingleBankboxFlier(param));
	};
	// (single_bankbox);
	function isDropped(idx: number | string) {
		if (showDrop.id === idx && showDrop.show) return true;
		else return false;
	}

	const bb = single_bankbox;
	const [showDeactivate, setShowDeactivate] = useState<{
		on: boolean;
		chi: BankBoxData;
	}>({
		on: false,
		chi: {} as BankBoxData,
	});
	const [showDrop, setShowDrop] = useState<{
		show: boolean;
		id: number | string;
	}>({
		show: false,
		id: '',
	});

	const navigate = useNavigate();

	const viewIcon = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				className="dull-bright-filter"
				d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				className="dull-bright-filter"
				d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	function DropMore({ className, idx, chi }: any) {
		return (
			<div className={`more-wrap merchant-wrap  drop ${className}`}>
				{getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'terminals'
				)?.includes('delete_terminals') && (
					<div
						style={{
							opacity: '1',
							cursor: 'pointer',
						}}
						onClick={() => {
							setShowDeactivate({
								on: true,
								chi: chi,
							});
						}}
						className="more_item"
					>
						<figure style={{ width: '2.5rem', height: '2.5rem' }}>
							{chi?.status === 1 ? (
								icons.deactivate_terminal
							) : (
								<svg
									className="img"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'contain',
									}}
								>
									<circle cx="12" cy="12" r="12" fill="#F7F8F7" />
									<path
										d="M16 9L10.5 14.5L8 12"
										stroke="#1ACE37"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							)}
						</figure>
						<p>
							{chi?.status === 1 ? 'Deactivate Terminal' : 'Activate BankBox'}
						</p>
					</div>
				)}
				<div
					style={{
						opacity: '1',
						cursor: 'pointer',
					}}
					onClick={() => {
						const obj = {
							serial_no: chi?.serial,
						};
						single_bankbox?.terminal?.serial !== chi?.serial &&
							dispatch(bankboxAPI?.getSingleBankbox(obj));
						setShowFlier(true);
					}}
					className="more_item"
				>
					<figure style={{ width: '2.5rem', height: '2.5rem' }}>
						{viewIcon}
					</figure>
					<p>View Payment Flier</p>
				</div>
				<div
					style={{
						opacity: '1',
						cursor: 'pointer',
					}}
					onClick={() => {
						setShowModalDelete(true);
					}}
					className="more_item"
				>
					<figure style={{ width: '2.5rem', height: '2.5rem' }}>
						<svg
							className="img"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
								stroke="#FF0F00"
								strokeWidth="1.2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</figure>
					<p style={{ color: '#FF0F00' }}>Delete Device</p>
				</div>
			</div>
		);
	}

	const threeDots = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
				stroke="var(--primary-base-color)"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
				stroke="var(--primary-base-color)"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
				stroke="var(--primary-base-color)"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	async function handleView(e: string) {
		// insert url param
		localStorage?.setItem('single-ter-serial', e);
		await navigate({
			pathname: ALL_ROUTES?.SINGLE_MERCHANT_VIEW_BANKBOX,
		});

		// append the query parameters
		// await insertUrlParam('serial', e, `Atlas: BankBox - SN:${e}`);
	}

	async function handleDeactivate() {
		const resp = await dispatch(
			bankboxAPI.deactivateBankbox({ serial_no: showDeactivate?.chi?.serial })
		);

		if (resp.payload.status === 'success') {
			setShowDeactivate({
				on: false,
				chi: {} as BankBoxData,
			});
			setShowAction(true);
			setRefreshTable(true);
		}
	}

	async function handleReactivate() {
		const resp = await dispatch(
			bankboxAPI.reactivateBankbox({ serial_no: showDeactivate?.chi?.serial })
		);

		if (resp.payload.status === 'success') {
			setShowDeactivate({
				on: false,
				chi: {} as BankBoxData,
			});
			setShowAction(false);
			setRefreshTable(true);
		}
	}
	const [color_value, setColorValue] = useState<string>('');
	function addHashIfNeeded(str: any) {
		if (/\d/.test(str) && !/^#/.test(str)) {
			return '#' + str;
		} else {
			return str;
		}
	}
	async function fetchProfile() {
		const resp = await dispatch(bankboxAPI.getProfile({}));

		if (resp.payload?.status === 'success') {
			const color_code = resp.payload.data.data?.color_code;

			setColorValue(addHashIfNeeded(color_code));
		}
	}
	useEffect(() => {
		if (Object?.keys(profile)?.length < 1) {
			fetchProfile();
		}
	}, []);

	const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
	const [loadingDelete, setLoadingDelete] = useState(false);
	async function handleDeleteTerminal() {
		setLoadingDelete(true);
		const resp = await dispatch(
			bankboxAPI.deleteBankbox({ serial_no: bb?.terminal?.serial })
		);

		if (resp.payload.status === 'success') {
			setShowModalDelete(false);
			setLoadingDelete(false);
		} else {
			setLoadingDelete(false);
		}
	}

	const merchant_email = localStorage?.getItem('merchant-email-user-preview');
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState('');
	const appColor = localStorage?.getItem('theme-color');

	type View = 'grid' | 'table';
	const [view, setView] = useState<View>('grid');

	const getInitialView = (): View => {
		const stored = localStorage?.getItem('terminal-details-view');
		return stored === 'grid' || stored === 'table' ? stored : 'grid';
	};

	const handleViewChange = (view: View) => {
		localStorage.setItem('terminal-details-view', view);
		setView(view);
	};

	function fetchVTerminals() {
		dispatch(
			bankboxAPI?.getVirtualBankBoxForMerchant({
				email: merchant_email,
				page: currentPage,
				perPage: 20,
			})
		);
	}
	function searchVTerminals() {
		dispatch(
			bankboxAPI?.searchVirtualBankBoxForMerchant({
				email: merchant_email,
				page: currentPage,
				perPage: 20,
				search: searchTerm,
			})
		);
	}
	function handlesearch(e: any) {
		setSearchTerm(e);
	}

	useEffect(() => {
		fetchVTerminals();
	}, [currentPage]);

	useEffect(() => {
		if (searchTerm) searchVTerminals();
	}, [searchTerm]);

	const totalItems = virtual_bankbox__merchant?.pagination?.totalItems;
	useEffect(() => {
		const stored = localStorage.getItem('terminal-details-view');
		if (stored === 'grid' || stored === 'table') return;

		if (totalItems && totalItems > 10) {
			setView('table');
			localStorage.setItem('terminal-details-view', 'table');
		}
	}, [totalItems]);

	return (
		<>
			<div
				style={{ marginBottom: '1.5rem' }}
				className="global-search-pagination-filter-box"
			>
				{' '}
				<SmartFilter
					searchTitle="Search by label"
					onSearchChange={debounce((e) => {
						handlesearch(e);
					}, 500)}
					hideFilter
					hideExport
					hideSearch
					page="virtual_bankboxes"
				/>
				<ViewToggle view={view} onchangeView={setView} baseColor={appColor!} />
				<div className="pagination-wrap">
					{' '}
					<Pagination
						className="top-bar__pagination"
						currentPage={currentPage}
						itemsPerPage={virtual_bankbox__merchant?.pagination?.perPage ?? 0}
						totalItems={virtual_bankbox__merchant?.pagination?.totalItems ?? 0}
						onPageChange={function (page: number): void {
							setCurrentPage(page);
						}}
					/>
				</div>
			</div>

			<div
			// onClick={() => {
			// 	console.log(all_bankbox__merchant);
			// }}
			>
				{loading ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '45vh',
							width: '100%',
						}}
					>
						<EmptyScreen
							loading={true}
							loadingText="Loading Terminals..."
							title="No Terminals Available"
							subTitle="Your terminals will be displayed here once they are loaded."
						/>
					</div>
				) : virtual_bankbox__merchant?.length < 1 ? (
					// If No Terminals Exist After Loading, Show Empty Screen
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '45vh',
							width: '100%',
						}}
					>
						<EmptyScreen
							loading={false}
							title="No Virtual Terminals Found"
							subTitle="You don’t have any virtual terminals yet."
						/>
					</div>
				) : (
					<div>
						{view === 'grid' && (
							<div className="user_terminal_details_general_container_holder_wrapper non-mobile">
								{virtual_bankbox__merchant?.data.map((chi: any, idx: any) => {
									return (
										<div
											onClick={() => {
												handleView(chi?.serial);
											}}
											// onClick={() => {
											// 	console.log(user_merchant);
											// }}
											key={idx}
											className="user_terminal_details_general_container_holder single-merchant-bg-color"
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
												}}
												className="header_content_holder_wrap"
											>
												<div>
													<p
														style={{ textTransform: 'capitalize' }}
														className="terminal_hearder_name"
													>
														{chi?.tid_label || '---'}
													</p>
													<p className="terminal_serial_number label">
														Serial No. • {chi?.serial}
													</p>
												</div>

												<RavenBadge
													text={chi?.status === 1 ? 'Active' : 'Inactive'}
													type={chi?.status === 1 ? 'green' : 'red'}
												/>
											</div>

											<div className="modal_content_holder_wrapper single-merchant-bg-color">
												<div className="modal_header_content">
													<div className="modal_header_content_users_assignee">
														<div>
															<figure>{usersSvg}</figure>
														</div>
														<p className="modal_header_content_assignee">
															{' '}
															{chi?.poseidon_business_email ? (
																<RavenCopyText
																	trimNum={30}
																	clickable
																	text={`	Assignee: ${
																		chi?.poseidon_business_email || '---'
																	}`}
																	copyValue={
																		chi?.poseidon_business_email || '---'
																	}
																	stopPropagation
																	color="deep-green-light"
																	copyIconColor="var(--primary-base-color)"
																	copyIconBgColor="var(--primary-accent-color-one)"
																	copiedBgColor="var(--primary-base-color)"
																/>
															) : (
																''
															)}
														</p>
													</div>

													{!loading && chi?.status === 1 && (
														<div
															className="white-black-bg"
															onClick={(e) => {
																e.stopPropagation();
																setShowDrop((prev) => ({
																	...prev,
																	id: chi?.id,
																	show:
																		showDrop?.id === chi?.id
																			? !showDrop.show
																			: true,
																}));
															}}
														>
															<div>
																<DropMore
																	stopPropagation
																	idx={chi?.id}
																	className={isDropped(chi?.id) && 'show-drop'}
																	chi={chi}
																/>
																{icons.three_dots(
																	theme === 'light' ? '#F7F7F7' : '#ffffff1a',
																	theme === 'light' ? '#020202' : '#ffffff'
																)}
															</div>
														</div>
													)}
												</div>

												<div className="modal_bottom_content">
													<div style={{ width: '45%' }}>
														<p className="modal_terminal_volumn">VOLUME</p>
														<p className="modal_terminal_volumn_content">
															{formatNumWithCommaNairaSymbolTwo(chi?.volume)}
														</p>
													</div>
													<div>
														<p className="modal_terminal_volumn">
															{/* Cash Out */}
														</p>
														<p className="modal_terminal_volumn_content">
															{/* {formatNumWithCommaNairaSymbolTwo(chi?.total_volume)} */}
														</p>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						)}

						{view === 'table' && (
							<TerminalTable
								loading={loading}
								tableData={virtual_bankbox__merchant}
								amount_key="cash_in"
							/>
						)}
					</div>
				)}
			</div>

			<DeleteModal
				onDelete={
					showDeactivate?.chi?.status === 1
						? handleDeactivate
						: handleReactivate
				}
				loading={loading}
				deleteText={
					showDeactivate.chi?.status === 1 ? 'Deactivate' : 'Activate'
				}
				buttonColor={showDeactivate.chi?.status !== 1 ? 'deep-green-light' : ''}
				visible={showDeactivate.on}
				onCancel={() =>
					setShowDeactivate({
						on: false,
						chi: {} as BankBoxData,
					})
				}
				title={
					showDeactivate.chi?.status === 1
						? 'Deactivate BankBox'
						: 'Activate BankBox'
				}
				text={
					showDeactivate.chi?.status === 1
						? 'Deactivating a BankBox suspend it from recieving or sending out money, are you sure you want to proceed?'
						: 'Activating this BankBox will activate the sending and receiving feature of the BankBox.'
				}
			/>

			<RavenModal
				className={`session-expired-wrap-modal flier-modal-btn-box`}
				// btnLabel="Download Flier"
				visble={showFlier}
				// visble={true}
				onBtnClick={() => {
					// setCaptureImg(!captureImg);
				}}
				btnColor="deep-green-light"
				onClose={() => {
					setCaptureImg(false);
					setShowFlier(false);
				}}
			>
				<div className="flier-modal-wrap-box">
					{/* <RavenFlier onCapture={captureImg} visible={showFlier} /> */}
					<FlierTwoIndex color_code={color_value} />
				</div>
			</RavenModal>

			<DeleteModal
				onDelete={handleDeleteTerminal}
				loading={loadingDelete}
				deleteText={`Delete Device`}
				buttonColor={''}
				visible={showModalDelete}
				onCancel={() => setShowModalDelete(false)}
				title={`Delete Device ( ${trimLongString(bb?.terminal?.serial, 15)} )`}
				text={`Deleting a BankBox remove it from recieving or sending out money, are you sure you want to proceed?`}
			/>
		</>
	);
};
export default UserVirtualTerminalDetails;
